import { FC, useEffect, Fragment } from 'react'
import {
  Typography,
  List,
  ListSubheader,
  Grid,
  Card,
  CardContent,
  Divider,
  Box,
  Link,
} from '@mui/material'

import { ItemEntryDetail } from '../../../services/slips'
import { SlipsScreenType, TabsEnums } from '../../../components'
import { PaymentListItemComponent } from './PaymentListItemComponent'
import { TitleActionBarComponent } from './TitleActionBarComponent'

interface PaymentItemComponentProps {
  data: ItemEntryDetail[]
  separatorHeight: number
  billId: number
  screenType: SlipsScreenType
  accountType?: string
  onSlipsEntriesUpdated?: () => void
}

export const col1 = 3
export const col2 = 2
export const col3 = 2
export const col4 = 2
export const col5 = 2
export const col6 = 1

export const PaymentItemComponent: FC<PaymentItemComponentProps> = ({
  data,
  separatorHeight,
  billId,
  screenType,
  accountType,
  onSlipsEntriesUpdated,
}) => {
  return (
    <Fragment>
      {data && data.length > 0 && (
        <Fragment>
          <Divider />
          <Grid
            id="properties_name"
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              minHeight: '4vh',
              pl: 2,
              pr: 2,
              backgroundColor: '#f9f9f9',
              fontWeight: 'bold',
              position: 'sticky',
              top: 0,
              zIndex: 997,
            }}
          >
            <Grid xs={col1} sx={{ pl: 0 }}>
              Payment Description
            </Grid>
            <Grid xs={col2} sx={{ textAlign: 'right', paddingRight: '28px' }}>Amount</Grid>
             <Grid xs={col3} sx={{ textAlign: 'left', paddingLeft: '30px' }}>TDS</Grid>
            <Grid xs={col4}>Date</Grid>
            <Grid xs={col5}>Status</Grid>
            <Grid xs={col6} sx={{ paddingLeft: 1 }}>
              Actions
            </Grid>
          </Grid>
          {data &&
            data.map((items, index) => {
             
              return (
                <List
                  sx={{
                    width: '100%',
                    p: 0,
                    m: 0,
                  }}
                  component="div"
                  aria-labelledby="subheader"
                  key={index}
                >
                  <Divider />
                      <TitleActionBarComponent
                                     data={items}
                                     onClickViewPDF={() => {}}
                                     screenType={screenType}
                                     billType={null}
                                     selectedTab="PAYMENT"
                                     accountId={billId}
                                     account={null}
                                   />
                  {items.itemEntries &&
                    items.itemEntries.map((item, i) => {
                      return (
                        <Fragment key={i}>
                          <Divider />
                          <PaymentListItemComponent
                            isSUM={item.itemName == 'SUM'}
                            item={item}
                            key={i}
                            componentName={TabsEnums.Payment}
                            billId={billId}
                            screenType={screenType}
                            accountType={accountType}
                            onSlipsEntriesUpdated={onSlipsEntriesUpdated}
                          />
                        </Fragment>
                      )
                    })}
                </List>
              )
            })}
        </Fragment>
      )}
    </Fragment>
  )
}
